// ─────────────────────────────────────────────────────────────
// analytics.js
// Thin wrapper around GA4 gtag. All tracking calls go through
// here so they're easy to find, disable, or swap out later.
//
// Replace G-XXXXXXXXXX in public/index.html with your real
// Measurement ID from Google Analytics → Admin → Data Streams.
// ─────────────────────────────────────────────────────────────

const gtag = (...args) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag(...args);
  }
};

// ── Pageview (called automatically by GA4 config, but useful for SPAs) ──
export const trackPageview = (path) => {
  gtag('event', 'page_view', { page_path: path });
};

// ── RSVP events ──────────────────────────────────────────────
export const trackRsvp = (response) => {
  // response: 'yes' | 'no' | 'maybe'
  gtag('event', 'rsvp_submitted', {
    event_category: 'engagement',
    rsvp_response: response,
  });
};

export const trackRsvpChanged = (from, to) => {
  gtag('event', 'rsvp_changed', {
    event_category: 'engagement',
    from_response: from,
    to_response: to,
  });
};

// ── SMS subscription ─────────────────────────────────────────
export const trackSmsSubscribed = () => {
  gtag('event', 'sms_subscribed', {
    event_category: 'engagement',
  });
};

export const trackSmsUnsubscribed = () => {
  gtag('event', 'sms_unsubscribed', {
    event_category: 'engagement',
  });
};

// ── Calendar events ──────────────────────────────────────────
export const trackCalendarGoogle = (eventType) => {
  // eventType: 'single' | 'series'
  gtag('event', 'calendar_google', {
    event_category: 'calendar',
    calendar_type: eventType,
  });
};

export const trackCalendarDownload = (eventType) => {
  // eventType: 'single' | 'series'
  gtag('event', 'calendar_download', {
    event_category: 'calendar',
    calendar_type: eventType,
  });
};

// ── Weather ──────────────────────────────────────────────────
export const trackWeatherClicked = () => {
  gtag('event', 'weather_clicked', {
    event_category: 'engagement',
  });
};

// ── Share ────────────────────────────────────────────────────
export const trackShareLink = () => {
  gtag('event', 'share', {
    event_category: 'engagement',
    method: 'copy_link',
  });
};
